import './_profil.scss';
// import pictCartoon from '../../img/PicID5.jpg'
import pictProfile from '../../img/Capture.png'
import React, { useRef } from 'react';
import { useEffect } from 'react';
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/all';
import { ScrollToPlugin } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const slideInTop = (elem) => {
    gsap.fromTo(
        elem,
        {
            opacity: 0,
            y: 100,
        },
        {
            opacity: 1,
            y: 0,
            delay: 0.2,
            duration: 1,
            scrollTrigger: {
                trigger: elem,
                start: "top center",
                end: "bottom center",
            },
        }
    )
}
const Profil = () => {

    // Slide section profil
    useEffect(() => {
        slideInTop('#profil');
    }, [])


    // animation ... infinie
    const textRef = useRef(null);
    useEffect(() => {
        const timeline = gsap.timeline({ repeat: -1 });

        const chars = Array.from(textRef.current.querySelectorAll('.display-dots'));

        timeline.from(chars, { opacity: 0, stagger: 0.5 })
            .to(chars, { opacity: 1, stagger: 0.5, delay: 0 })
            .from(chars.reverse(), { opacity: 1, stagger: 0.5 })
            .to(chars.reverse(), { opacity: 0, stagger: 0.5, delay: 0 })

        return () => {
            timeline.kill();
        };
    }, []);



    return (
        <section id='profil'>
            <div className='profil-container'>
                <div className="profil-presentation">
                    <div className="title">
                        <h2 className='profil-title'>A propos de moi<span ref={textRef}><span className='display-dots'>.</span><span className='display-dots'>.</span><span className='display-dots'>.</span></span></h2>
                    </div>
                    <div className='profil-pict'>
                        <img className="profil-pict-main" src={pictProfile} alt='Mohamed Coulibaly' />
                    </div>
                    <div className="profil-presentation-txt">
                        <p>Bonjour,</p>
                        <p>Je suis <span>Mohamed Coulibaly</span>, <span>Développeur Web Fullstack</span> basé à Bamako, Mali. Diplômé en <span>Génie Logiciel</span> (Licence à l'Université Technolab Ista, option Technologie Web), je suis passionné par la conception d'architectures logicielles robustes et l'innovation technologique, notamment dans les domaines de l'<span>IA</span> et de l'<span>IoT</span>.</p>
                        <p>Depuis <span>2022</span>, j'exerce en tant que <span>développeur freelance</span>, concevant des applications web sur mesure avec des technologies telles que <span>React.js</span> en front-end et <span>Laravel</span> en back-end. J'interviens également sur l'intégration de sites vitrines et e-commerce via <span>WordPress</span>, avec une attention particulière au <span>SEO</span> et à la performance. En amont du développement, je réalise des analyses de besoins incluant la rédaction de cahiers des charges et la modélisation des données (<span>UML/Merise</span>).</p>
                        <p>Mon cœur de métier s'articule autour de <span>React.js</span>, <span>Laravel</span>, <span>PHP</span>, <span>JavaScript (ES6+)</span>, <span>HTML5/CSS3</span> et <span>MySQL</span>. Je maîtrise aussi des outils DevOps comme <span>Git/GitHub</span>, <span>Docker</span> et <span>Linux</span>, ainsi que des technologies secondaires comme <span>Python (Django)</span>, <span>Node.js</span> et <span>Flutter</span>.</p>
                        <p>Autodidacte et en apprentissage continu, j'ai suivi des formations sur <span>OpenClassrooms</span>, <span>FreeCodeCamp</span> et le célèbre <span>CS50 de Harvard</span>. Curieux, rigoureux et motivé, je recherche des défis techniques stimulants pour créer de la valeur ajoutée. N'hésitez pas à me contacter !</p>

                    </div>
                </div>
            </div>
        </section>
    )

}
export default Profil;
